import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Thermo from './views/Thermo.vue'
import Login from './views/Login.vue'
import SignUp from './views/SignUp.vue'
import AsigDevice from './views/AsigDevice.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },

    {
      path: '/sign-up',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/asig-device',
      name: 'asigdevice',
      component: AsigDevice
    },
    {
      path: '/thermo',
      name: 'thermo',
      props: true,
      component: Thermo,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.

    },
    {
      path: '/home',
      name: 'home',
      props: true,
      component: Home,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.

    }
  ]
})
